import { Route, Routes } from 'react-router-dom';

import SongbookHome from './Songbook/SongbookHome.tsx';
import SongbookDetail from './Songbook/SongbookDetail.tsx';
import SongDetail from './Song/SongDetail.tsx';

function SongbookRoutes() {
  return (
    <Routes>
      <Route element={<SongDetail />} path="/:songbookId/song/:songId" />
      <Route element={<SongbookDetail />} path="/:songbookId" />
      <Route element={<SongbookHome />} path="/" />
    </Routes>
  );
}

export default SongbookRoutes;
